module.exports = __webpack_public_path__ + "static/media/alert.a69f69f5.mp3";